module.exports = __webpack_public_path__ + "img/perview-img.ff77b72.svg";